export const FIREBASE_AUTH_ERROR_MESSAGES = {
  "auth/invalid-email": "Nieprawidłowy e-mail.",
  "auth/email-already-in-use":
    "Konto dla podanego adresu email już istnieje. Skorzystaj z funkcji przypominania hasła.",
  "auth/user-not-found": "Nie znaleziono użytkownika o podanym adresie email.",
  "auth/wrong-password": "Nieprawidłowe aktualne hasło.",
  "auth/internal-error": "Błąd logowania.",
  "auth/too-many-requests": "Podjęto zbyt wiele prób. Spróbuj ponownie później.",
  "auth/session-cookie-expired": "Dostarczony plik cookie sesji Firebase wygasł.",
  "auth/invalid-credential": "Nieprawidłowe dane logowania.",
  "auth/weak-password": "Hasło jest zbyt słabe. Użyj hasła o długości co najmniej 6 znaków.",
  "auth/invalid-password": "Nieprawidłowe hasło.",
  "auth/operation-not-allowed": "Operacja nie jest dozwolona.",
  "auth/network-request-failed": "Błąd połączenia sieciowego.",
  "auth/user-disabled": "Konto zostało wyłączone.",
  "auth/account-exists-with-different-credential":
    "Konto z tym adresem email już istnieje z innymi danymi logowania.",
  "auth/requires-recent-login": "Wymagane jest ponowne logowanie.",
  "auth/invalid-verification-code": "Nieprawidłowy kod weryfikacyjny.",
  "auth/invalid-verification-id": "Nieprawidłowy identyfikator weryfikacji.",
  "auth/missing-verification-code": "Brak kodu weryfikacyjnego.",
  "auth/missing-verification-id": "Brak identyfikatora weryfikacji.",
  "auth/quota-exceeded": "Przekroczono limit żądań.",
  "auth/captcha-check-failed": "Weryfikacja CAPTCHA nie powiodła się.",
  "auth/invalid-phone-number": "Nieprawidłowy numer telefonu.",
  "auth/missing-phone-number": "Brak numeru telefonu.",
  "auth/invalid-recipient-email": "Nieprawidłowy adres email odbiorcy.",
  "auth/invalid-sender": "Nieprawidłowy nadawca.",
  "auth/invalid-continue-uri": "Nieprawidłowy URI kontynuacji.",
  "auth/unauthorized-continue-uri": "Nieautoryzowany URI kontynuacji.",
  "auth/invalid-dynamic-link-domain": "Nieprawidłowa domena linku dynamicznego.",
  "auth/argument-error": "Błąd argumentu.",
  "auth/invalid-persistence-type": "Nieprawidłowy typ trwałości.",
  "auth/unsupported-persistence-type": "Nieobsługiwany typ trwałości.",
  "auth/invalid-tenant-id": "Nieprawidłowy identyfikator najemcy.",
  "auth/tenant-id-mismatch": "Niezgodność identyfikatora najemcy.",
  "auth/invalid-multi-factor-session": "Nieprawidłowa sesja wieloczynnikowa.",
  "auth/missing-multi-factor-session": "Brak sesji wieloczynnikowej.",
  "auth/invalid-multi-factor-hint": "Nieprawidłowa wskazówka wieloczynnikowa.",
  "auth/missing-multi-factor-hint": "Brak wskazówki wieloczynnikowej.",
  "auth/invalid-multi-factor-credential": "Nieprawidłowe dane wieloczynnikowe.",
  "auth/missing-multi-factor-credential": "Brak danych wieloczynnikowych.",
  "auth/missing-email": "Brak adresu email.",
  "auth/missing-password": "Brak hasła.",
} as const;
